<template>
    <layout>
        <v-row 
            align="center"
            justify="center"
        > 
            <v-card
                class="pa-6" 
                width="500"
            >  
                <v-app-bar
                    flat
                    color="primary"
                >
                    <v-toolbar-title class="title white--text pl-0">
                        REQUIRED DOCUMENTS
                    </v-toolbar-title>
                </v-app-bar>
                <v-row 
                    align="center"
                    justify="center" 
                    class="mt-3"                  
                >
                    <v-col
                        cols="12"                        
                    >
                        Please upload a scanned copy of the required documents
                        in the appropriate fields below
                    </v-col>
                </v-row>
            </v-card>
        </v-row>

        <v-row
            v-for="document in documents"
            :key="document.label"
        >
            <upload-files 
                v-bind:fileType="document.type"
                v-bind:fileLabel="document.label"
                v-bind:fileTypeAllowed="document.fileAllowed"
                v-bind:fileAccept="document.fileAccept"
            ></upload-files>
        </v-row>
        
    </layout>    
</template>

<script>
import Layout from './layouts/Registration';
import UploadFiles from "./UploadFiles";

export default {
    name: 'Documents',

    components: {
        Layout,
        UploadFiles,
        
    },    

    data: () => ({        
        documents: [
            {
                label: 'Birth Certificate', 
                placeholder: 'Upload your birth certificate', 
                type: 'birth_certificate',
                ref: 'birth_certificate',
                fileAllowed: 'pdf',
                fileAccept: '.pdf'
            },
            {
                label: 'Immunization Card', 
                placeholder: 'Upload your immunization card', 
                type: 'immunization_card',
                ref: 'immunization_card',
                fileAllowed: 'pdf',
                fileAccept: '.pdf',
            },
            {
                label: 'SEA Slip', 
                placeholder: 'Upload your SEA results slip', 
                type: 'sea_slip',
                ref: 'sea_slip',
                fileAllowed: 'pdf',
                fileAccept: '.pdf',
            },
            {
                label: 'Passport Photo', 
                placeholder: 'Upload Passport Photo', 
                type: 'picture',
                ref: 'picture',
                fileAllowed: 'jpeg/png',
                fileAccept: 'image/*'
            },
            {
                label: 'Parent/Guardian ID', 
                placeholder: 'Upload Passport Photo', 
                type: 'parent_id',
                ref: 'parent_id',
                fileAllowed: 'pdf',
                fileAccept: '.pdf',
            },
            // {
            //     label: 'Passport Bio Page', 
            //     placeholder: 'Upload Passport Bio Page', 
            //     type: 'passport',
            //     ref: 'passport',
            //     fileAllowed: 'jpeg/png',
            //     fileAccept: 'image/*'
            // },
            // {
            //     label: 'Non National Student Permit', 
            //     placeholder: 'Upload Non National Student Permit', 
            //     type: 'student_permit',
            //     ref: 'student_permit',
            //     fileAllowed: 'jpeg/png',
            //     fileAccept: 'image/*'
            // },
            // {
            //     label: 'Bank Receipt for School Contribution', 
            //     placeholder: 'Upload Receipt', 
            //     type: 'contribution_receipt',
            //     ref: 'contribution_receipt',
            //     fileAllowed: 'pdf',
            //     fileAccept: '.pdf',
            // },
        ],      
        
    }),
    
}
</script>